<template>
    <div class="qksm qksm1">
        <div class="nogap">
            <h4>一、收入支出决算总体情况说明</h4>
            <p>
                {{$store.state.divData.divname}}2020年度收入、支出总计{{isMoney(T1.收入.总计)}}万元，与上年
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收支去年" v-model:value="T1.收入.总计_last"></reason>万元）
                </span>
                <template v-if="num(T1.收入.总计).toFixed(2)==num(T1.收入.总计_last).toFixed(2)">
                    收、支总计各相同。
                </template>
                <template v-else>
                    相比收、支总计各{{growthValueText(T1.收入.总计,T1.收入.总计_last)}}万元
                    <template v-if="T1.收入.总计!=T1.收入.总计_last && num(T1.收入.总计_last)==0">
                        {{$store.state.divData.zone=='xuzhou' ? "。" : "（去年决算数为0万元，无法计算增减比率）。"}}
                    </template>
                    <template v-else>
                        ，{{growthRatioText(T1.收入.总计,T1.收入.总计_last)}}。
                    </template>
                </template>
                其中：
            </p>
            <p><b>（一）收入总计{{isMoney(T1.收入.总计)}}万元。包括：</b></p>
            <p>
                1．一般公共预算财政拨款收入{{isMoney(T1.收入.项_1)}}万元，
                <template v-if="num(T1.收入.项_1)!=0">
                    为当年从同级财政取得的一般公共预算拨款，
                </template>
                <template v-else>
                    当年未从同级财政取得一般公共预算拨款，
                </template>
                与上年
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_1_去年" v-model:value="T1.收入.项_1_last"></reason>万元）
                </span>
                <template v-if="num(T1.收入.项_1).toFixed(2)==num(T1.收入.项_1_last).toFixed(2)">
                    决算数相同。
                </template>
                <template v-else>
                    相比{{growthValueText(T1.收入.项_1,T1.收入.项_1_last)}}万元
                    <template v-if="T1.收入.项_1!=T1.收入.项_1_last && num(T1.收入.项_1_last)==0">
                        {{$store.state.divData.zone=='xuzhou' ? "。" : "（去年决算数为0万元，无法计算增减比率）。"}}
                    </template>
                    <template v-else>
                        ，{{growthRatioText(T1.收入.项_1,T1.收入.项_1_last)}}。
                    </template>
                    主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_1" v-model:value="qksm['原因收入项_1']"></reason>
                </template>
            </p>
            <p>
                2．政府性基金预算财政拨款收入{{isMoney(T1.收入.项_2)}}万元，
                <template v-if="num(T1.收入.项_2)!=0">
                    为当年从同级财政取得的政府性基金预算拨款，
                </template>
                <template v-else>
                    当年未从同级财政取得政府性基金预算拨款，
                </template>
                与上年
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_2_去年" v-model:value="T1.收入.项_2_last"></reason>万元）
                </span>
                <template v-if="num(T1.收入.项_2).toFixed(2)==num(T1.收入.项_2_last).toFixed(2)">
                    决算数相同。
                </template>
                <template v-else>
                    相比{{growthValueText(T1.收入.项_2,T1.收入.项_2_last)}}万元
                    <template v-if="T1.收入.项_2!=T1.收入.项_2_last && num(T1.收入.项_2_last)==0">
                        {{$store.state.divData.zone=='xuzhou' ? "。" : "（去年决算数为0万元，无法计算增减比率）。"}}
                    </template>
                    <template v-else>
                        ，{{growthRatioText(T1.收入.项_2,T1.收入.项_2_last)}}。
                    </template>
                    主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_2" v-model:value="qksm['原因收入项_2']"></reason>
                </template>
            </p>
            <p>
                3．国有资本经营预算财政拨款收入{{isMoney(T1.收入.项_3)}}万元，
                <template v-if="num(T1.收入.项_3)!=0">
                    为当年从同级财政取得的国有资本经营预算拨款，
                </template>
                <template v-else>
                    当年未从同级财政取得国有资本经营预算拨款，
                </template>
                与上年
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_3_去年" v-model:value="T1.收入.项_3_last"></reason>万元）
                </span>
                <template v-if="num(T1.收入.项_3).toFixed(2)==num(T1.收入.项_3_last).toFixed(2)">
                    决算数相同。
                </template>
                <template v-else>
                    相比{{growthValueText(T1.收入.项_3,T1.收入.项_3_last)}}万元
                    <template v-if="T1.收入.项_3!=T1.收入.项_3_last && num(T1.收入.项_3_last)==0">
                        {{$store.state.divData.zone=='xuzhou' ? "。" : "（去年决算数为0万元，无法计算增减比率）。"}}
                    </template>
                    <template v-else>
                        ，{{growthRatioText(T1.收入.项_3,T1.收入.项_3_last)}}。
                    </template>
                    主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_3" v-model:value="qksm['原因收入项_3']"></reason>
                </template>
            </p>
            <p>
                4．上级补助收入{{isMoney(T1.收入.项_4)}}万元，
                <reason v-if="num(T1.收入.项_4)!=0" type="textarea" classname="qksm widest" name="上级补助收入单位" v-model:value="qksm['上级补助收入单位']" placeholder="为XX等事业单位收到上级单位拨入的非财政补助资金"></reason>
                <template v-else>
                    本部门当年无事业单位收到上级单位拨入的非财政补助资金。
                </template>
                与上年
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_4_去年" v-model:value="T1.收入.项_4_last"></reason>万元）
                </span>
                <template v-if="num(T1.收入.项_4).toFixed(2)==num(T1.收入.项_4_last).toFixed(2)">
                    决算数相同。
                </template>
                <template v-else>
                    相比{{growthValueText(T1.收入.项_4,T1.收入.项_4_last)}}万元
                    <template v-if="T1.收入.项_4!=T1.收入.项_4_last && num(T1.收入.项_4_last)==0">
                        {{$store.state.divData.zone=='xuzhou' ? "。" : "（去年决算数为0万元，无法计算增减比率）。"}}
                    </template>
                    <template v-else>
                        ，{{growthRatioText(T1.收入.项_4,T1.收入.项_4_last)}}。
                    </template>
                    主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_4" v-model:value="qksm['原因收入项_4']"></reason>
                </template>
            </p>
            <p>
                5．事业收入{{isMoney(T1.收入.项_5)}}万元，
                <reason v-if="num(T1.收入.项_5)!=0" type="textarea" classname="qksm widest" name="事业收入单位" v-model:value="qksm['事业收入单位']" placeholder="为XX等事业单位开展XX专业业务活动及其辅助活动取得的收入"></reason>
                <template v-else>
                    本部门当年无事业单位开展专业业务活动及其辅助活动取得的收入。
                </template>
                与上年
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_5_去年" v-model:value="T1.收入.项_5_last"></reason>万元）
                </span>
                <template v-if="num(T1.收入.项_5).toFixed(2)==num(T1.收入.项_5_last).toFixed(2)">
                    决算数相同。
                </template>
                <template v-else>
                    相比{{growthValueText(T1.收入.项_5,T1.收入.项_5_last)}}万元
                    <template v-if="T1.收入.项_5!=T1.收入.项_5_last && num(T1.收入.项_5_last)==0">
                        {{$store.state.divData.zone=='xuzhou' ? "。" : "（去年决算数为0万元，无法计算增减比率）。"}}
                    </template>
                    <template v-else>
                        ，{{growthRatioText(T1.收入.项_5,T1.收入.项_5_last)}}。
                    </template>
                    主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_5" v-model:value="qksm['原因收入项_5']"></reason>
                </template>
            </p>
            <p>
                6．经营收入{{isMoney(T1.收入.项_6)}}万元，
                <reason type="textarea" v-if="num(T1.收入.项_6)!=0" classname="qksm widest" name="经营收入单位" v-model:value="qksm['经营收入单位']" placeholder="为XX等事业单位在专业业务活动及其辅助活动之外开展非独立核算经营活动取得的收入"></reason>
                <template v-else>
                    本部门当年无事业单位在专业业务活动及其辅助活动之外开展非独立核算经营活动取得的收入。
                </template>
                与上年
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_6_去年" v-model:value="T1.收入.项_6_last"></reason>万元）
                </span>
                <template v-if="num(T1.收入.项_6).toFixed(2)==num(T1.收入.项_6_last).toFixed(2)">
                    决算数相同。
                </template>
                <template v-else>
                    相比{{growthValueText(T1.收入.项_6,T1.收入.项_6_last)}}万元
                    <template v-if="T1.收入.项_6!=T1.收入.项_6_last && num(T1.收入.项_6_last)==0">
                        {{$store.state.divData.zone=='xuzhou' ? "。" : "（去年决算数为0万元，无法计算增减比率）。"}}
                    </template>
                    <template v-else>
                        ，{{growthRatioText(T1.收入.项_6,T1.收入.项_6_last)}}。
                    </template>
                    主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_6" v-model:value="qksm['原因收入项_6']"></reason>
                </template>
            </p>
            <p>
                7．附属单位上缴收入{{isMoney(T1.收入.项_7)}}万元，
                <reason v-if="num(T1.收入.项_7)!=0" type="textarea" classname="qksm widest" name="附属单位上缴收入单位" v-model:value="qksm['附属单位上缴收入单位']" placeholder="为XX等事业单位附属独立XX核算单位按照有关规定上缴的收入"></reason>
                <template v-else>
                    本部门当年无事业单位附属独立核算单位按照有关规定上缴的收入。
                </template>
                与上年
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_7_去年" v-model:value="T1.收入.项_7_last"></reason>万元）
                </span>
                <template v-if="num(T1.收入.项_7).toFixed(2)==num(T1.收入.项_7_last).toFixed(2)">
                    决算数相同。
                </template>
                <template v-else>
                    相比{{growthValueText(T1.收入.项_7,T1.收入.项_7_last)}}万元
                    <template v-if="T1.收入.项_7!=T1.收入.项_7_last && num(T1.收入.项_7_last)==0">
                        {{$store.state.divData.zone=='xuzhou' ? "。" : "（去年决算数为0万元，无法计算增减比率）。"}}
                    </template>
                    <template v-else>
                        ，{{growthRatioText(T1.收入.项_7,T1.收入.项_7_last)}}。
                    </template>
                    主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_7" v-model:value="qksm['原因收入项_7']"></reason>
                </template>
            </p>
            <p>
                8．其他收入{{isMoney(T1.收入.项_8)}}万元，
                <template v-if="num(T1.收入.项_8)!=0">
                    为单位取得的除上述收入以外的各项收入，主要为
                    <reason type="textarea" classname="qksm widest" name="其他收入单位" v-model:value="qksm['其他收入单位']" placeholder="XX单位取得的XX收入"></reason>
                </template>
                <template v-else>
                    本部门当年无单位取得的除上述收入以外的各项收入。
                </template>
                与上年
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="收入项_8_去年" v-model:value="T1.收入.项_8_last"></reason>万元）
                </span>
                <template v-if="num(T1.收入.项_8).toFixed(2)==num(T1.收入.项_8_last).toFixed(2)">
                    决算数相同。
                </template>
                <template v-else>
                    相比{{growthValueText(T1.收入.项_8,T1.收入.项_8_last)}}万元
                    <template v-if="T1.收入.项_8!=T1.收入.项_8_last && num(T1.收入.项_8_last)==0">
                        {{$store.state.divData.zone=='xuzhou' ? "。" : "（去年决算数为0万元，无法计算增减比率）。"}}
                    </template>
                    <template v-else>
                        ，{{growthRatioText(T1.收入.项_8,T1.收入.项_8_last)}}。
                    </template>
                    主要原因是
                    <reason type="textarea" classname="qksm widest" name="原因收入项_8" v-model:value="qksm['原因收入项_8']"></reason>
                </template>
            </p>
            <p>
                9．使用非财政拨款结余{{isMoney(T1.收入.项_9)}}万元，
                <template v-if="num(T1.收入.项_9)!=0">
                    为事业单位使用非财政拨款结余（原事业基金）弥补当年收支差额的数额。主要为
                    <reason type="textarea" classname="qksm widest" name="非财政拨款单位" v-model:value="qksm['非财政拨款单位']" placeholder="XX等单位使用以前年度积累的非财政拨款结余（原事业基金）弥补当年收支缺口的资金"></reason>
                </template>
                <template v-else>
                    本部门当年无事业单位使用非财政拨款结余（原事业基金）弥补当年收支差额的数额。
                </template>
            </p>
            <p>
                10．年初结转和结余{{isMoney(T1.收入.项_10)}}万元，
                <template v-if="num(T1.收入.项_10)!=0">
                    主要为
                    <reason type="textarea" classname="qksm widest" name="年初结转单位" v-model:value="qksm['年初结转单位']" placeholder="XX单位上年结转本年使用的XX等资金"></reason>
                </template>
                <template v-else>
                    本部门当年无上年结转本年使用的资金。
                </template>

            </p>
            <p><b>（二）支出总计{{isMoney(T1.支出.总计)}}万元。包括：</b></p>
            <template v-for="(item,idx) in T1.支出.项目" :key="idx">
                <p v-if="item.name=='结余分配'">
                    {{idx+1}}.{{item.name}}{{isMoney(item.value)}}万元
                    <template v-if="num(item.value)!=0">
                        ，为单位当年结余的分配情况，主要是
                        <reason type="textarea" classname="qksm widest" name="结余事业单位" v-model:value="qksm['结余事业单位']" placeholder="XX等事业单位对非财政补助结余按规定计算缴纳的企业所得税、提取的职工福利基金等"></reason>
                    </template>
                    <template v-else>
                        。
                    </template>
                    与上年
                    <span class="hide_pdf">
                        （去年决算数<reason type="money" classname="qksm money nullable" :name="item.name+'支出去年'" v-model:value="item.valuelast"></reason>万元）
                    </span>
                    <template v-if="num(item.value).toFixed(2)==num(item.valuelast).toFixed(2)">
                        决算数相同。
                    </template>
                    <template v-else>
                        相比{{growthValueText(item.value,item.valuelast)}}万元
                        <template v-if="item.value!=item.valuelast && num(item.valuelast)==0">
                            {{$store.state.divData.zone=='xuzhou' ? "。" : "（去年决算数为0万元，无法计算增减比率）。"}}
                        </template>
                        <template v-else>
                            ，{{growthRatioText(item.value,item.valuelast)}}。
                        </template>
                        主要原因是
                        <reason type="textarea" classname="qksm widest" :name="item.name+'支出原因'" v-model:value="qksm[item.name+'支出原因']"></reason>
                    </template>
                </p>
                <p v-else-if="item.name=='年末结转和结余'">
                    {{idx+1}}.{{item.name}}{{isMoney(item.value)}}万元
                    <template v-if="num(item.value)!=0">
                        ，主要为
                        <reason type="textarea" classname="widest qksm" name="年末结转项目" v-model:value="qksm['年末结转项目']" placeholder="XX等单位本年度（或以前年度）预算安排的XX等项目无法按原计划实施，需要延迟到以后年度按有关规定使用的资金"></reason>
                    </template>
                    <template v-else>
                        。
                    </template>
                </p>
                <p v-else>
                    {{idx+1}}.{{item.name.replace("支出","")}}（类）支出{{isMoney(item.value)}}万元，主要用于
                    <reason type="textarea" classname="qksm widest" :name="item.name+'支出主要用于'" v-model:value="qksm[item.name+'支出主要用于']"></reason>
                    与上年
                    <span class="hide_pdf">
                        （去年决算数<reason type="money" classname="qksm money nullable" :name="item.name+'支出去年'" v-model:value="item.valuelast"></reason>万元）
                    </span>
                    <template v-if="num(item.value).toFixed(2)==num(item.valuelast).toFixed(2)">
                        决算数相同。
                    </template>
                    <template v-else>
                        相比{{growthValueText(item.value,item.valuelast)}}万元
                        <template v-if="item.value!=item.valuelast && num(item.valuelast)==0">
                            {{$store.state.divData.zone=='xuzhou' ? "。" : "（去年决算数为0万元，无法计算增减比率）。"}}
                        </template>
                        <template v-else>
                            ，{{growthRatioText(item.value,item.valuelast)}}。
                        </template>
                        主要原因是
                        <reason type="textarea" classname="qksm widest" :name="item.name+'支出原因'" v-model:value="qksm[item.name+'支出原因']"></reason>
                    </template>
                </p>
            </template>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm1",
        data() {
            var qksm = this.$store.state.divData.qksm;
            if (qksm['收支去年'])
                this.T1['收入']['总计_last'] = qksm['收支去年'];
            for (var i = 1; i <= 8; i++) {
                if (qksm['收入项_' + i + '_去年'])
                    this.T1['收入']['项_' + i + '_last'] = qksm['收入项_' + i + '_去年'];
            }
            for (let a of this.T1.支出.项目) {
                let v = qksm[a.name + '支出去年'];
                if (v)
                    a.valuelast = v;
                else {
                    a.valuelast = (this.T1.支出.项目_last.find(e => e.name == a.name) || { value: 0 }).value;
                }
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },

        props: {
            T1: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
    };
</script>